import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { ButtonComponent } from '../../button/button.component';
import { MegamenuCarouselComponent } from '../megamenu-carousel/megamenu-carousel.component';
import { MegamenuSubsectionComponent } from '../megamenu-subsection/megamenu-subsection.component';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslocoModule } from '@jsverse/transloco';
import { YesCategory } from '../megamenu.types';
import { A11yModule } from '@angular/cdk/a11y';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'section[app-megamenu-section]',
  imports: [
    ButtonComponent,
    MegamenuCarouselComponent,
    MegamenuSubsectionComponent,
    SvgIconComponent,
    TranslocoModule,
    A11yModule,
  ],
  templateUrl: './megamenu-section.component.html',
  styleUrls: ['./megamenu-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MegamenuSectionComponent {
  private readonly nativeElement: HTMLElement = inject(ElementRef).nativeElement;

  @Input()
  category!: YesCategory;

  @Output()
  closeMenu = new EventEmitter();

  @Output()
  closeSubmenu = new EventEmitter();

  @ViewChild(MegamenuSubsectionComponent)
  firstSubsection!: MegamenuSubsectionComponent;

  get offsetHeight(): number {
    return this.nativeElement.offsetHeight;
  }

  focus(): void {
    this.firstSubsection.focus();
  }
}
